module.exports = __webpack_public_path__ + "media/images/athletes/885-d947cdfeb08fbe04981cdbb077237a56.png";